/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Columns_PinnedInputs */



/**
* | output |
* | --- |
* | "Pinned" |
*
* @param {Editor_Table_Columns_PinnedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_columns_pinned = /** @type {((inputs?: Editor_Table_Columns_PinnedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Columns_PinnedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fixee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Angepinnt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fissato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закреплено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fija")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("置顶")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ピン留め")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिन की गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fixado")
	return /** @type {LocalizedString} */ ("Pinned")
});